exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-views-pages-case-tsx": () => import("./../../../src/views/pages/Case.tsx" /* webpackChunkName: "component---src-views-pages-case-tsx" */),
  "component---src-views-pages-latest-tsx": () => import("./../../../src/views/pages/Latest.tsx" /* webpackChunkName: "component---src-views-pages-latest-tsx" */),
  "component---src-views-pages-page-tsx": () => import("./../../../src/views/pages/Page.tsx" /* webpackChunkName: "component---src-views-pages-page-tsx" */)
}

